module.exports = __webpack_public_path__ + "78020087a838e771f8bccf9c99bdb3a6.png";